var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar"},[_vm._l((_vm.menuLinks),function(menuLink,lIdx){return [_c('router-link',{key:'menulink' + lIdx,class:{
        'router-link-active':
          menuLink.to.name.split('-')[0] == _vm.$route.name.split('-')[0],
      },attrs:{"to":menuLink.to}},[_c('div',{staticClass:"menu-element"},[_c('div',{staticClass:"element-label"},[_vm._v(" "+_vm._s(menuLink.label)+" ")])])])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }